import { useEffect, useRef } from 'react';

interface StreamingMessageProps {
  content: string;
  isStreaming?: boolean;
}

/**
 * Component for displaying streaming messages with typing indicator.
 */
export const StreamingMessage = ({ content, isStreaming = false }: StreamingMessageProps) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Auto-scroll to bottom as content streams
    if (contentRef.current) {
      contentRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, [content]);

  return (
    <div className="flex flex-col gap-2 p-4 bg-card rounded-lg border border-border">
      <div ref={contentRef} className="text-base">
        {content}
        {isStreaming && (
          <span
            className="inline-block w-2 h-4 bg-foreground ml-1"
            style={{
              animation: 'blink 1s infinite',
            }}
          />
        )}
      </div>
      {isStreaming && (
        <div className="flex items-center gap-2 mt-2">
          <div className="h-4 w-4 animate-spin rounded-full border-2 border-primary border-t-transparent" />
          <span className="text-xs text-muted-foreground">
            Agent is thinking...
          </span>
        </div>
      )}
      <style>{`@keyframes blink { 0%, 50% { opacity: 1; } 51%, 100% { opacity: 0; } }`}</style>
    </div>
  );
};
